export const DISCONNECT_SOCKET = 'DISCONNECT_SOCKET';
